import { createReducer, on } from '@ngrx/store';
import { ResetPasswordOutput } from 'aws-amplify/auth';
import {
  confirmResetPasswordFailure,
  resendResetPasswordCode,
  resetPassword,
  resetPasswordRestoreInitialState,
  sendResetPasswordCode,
  sendResetPasswordCodeFailure,
  sendResetPasswordCodeSuccess,
} from './reset-password.actions';

export const RESET_PASSWORD__FEATURE_KEY = 'reset-password';

/**
 * Represents the state of the reset password.
 */
export type ResetPasswordState = {
  processing?: boolean;

  /**
   * Whether the reset password is being processed.
   */
  loading?: boolean;

  /**
   * Whether the verification code is being resent.
   */
  resending?: boolean;

  /**
   * Whether the verification code has been sent.
   */
  sended?: boolean;

  /**
   * The number of times the verification code has been sent.
   */
  sendVerificationCodeCount?: number;

  password?: string;
  username?: string;
  attributeKey?: string;
  resetPasswordOutput?: ResetPasswordOutput;

  /**
   * The error that occurred during the process.
   */
  formErrors?: Record<string, Record<string, boolean>> | Record<string, any>;
};

const initialResetPasswordState: ResetPasswordState = {
  loading: false,
  password: '',
  username: '',
  resending: false,
  sended: false,
  formErrors: {},
};

export const resetPasswordReducer = createReducer<ResetPasswordState>(
  initialResetPasswordState,
  on(resetPassword, (state, { password, username, attributeKey }) => ({
    ...state,
    password,
    username,
    attributeKey,
    processing: false,
  })),
  on(resetPasswordRestoreInitialState, (state) => ({
    ...initialResetPasswordState,
  })),
  on(sendResetPasswordCode, (state) => ({
    ...state,
    processing: true,
  })),
  on(resendResetPasswordCode, (state) => ({
    ...state,
    processing: true,
    resending: true,
  })),
  on(sendResetPasswordCode, (state) => ({
    ...state,
    resending: true,
  })),
  on(sendResetPasswordCodeSuccess, (state, { data }) => ({
    ...state,
    processing: false,
    resending: false,
    resetPasswordOutput: data,
    sended: !!data.nextStep.codeDeliveryDetails.attributeName,
  })),
  on(confirmResetPasswordFailure, (state, { error }) => ({
    ...state,
    processing: false,
    resending: false,
    formErrors: { code: error.name },
  })),
  on(sendResetPasswordCodeFailure, (state, { error }) => ({
    ...state,
    processing: false,
    resending: false,
    formErrors: { code: error.name },
  })),
);
